import PropTypes from "prop-types";
import List from "app/pages/.shared/List";
import "./AlertMessage.scss";
import classNames from "classnames";
import { ALERT_TYPE } from "app/constants";
import { alertTypeProptypes } from "app/utils/propTypes";
import { useEffect, useRef } from "react";
import { scrollToElement } from "app/utils/scroller";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import {
	CheckmarkCircleStrokeIcon,
	WarningStrokeIcon,
	InfoCircleStrokeIcon,
} from "app/icons/navigation";

const AlertMessage = ({
	errors = [],
	message,
	alertType,
	children,
	scrollOnShow = false,
	className,
	withIcon = true,
}) => {
	let icon = <InfoCircleStrokeIcon height={16} width={16} className="icon" />;

	if (alertType === ALERT_TYPE.SUCCESS) {
		icon = <CheckmarkCircleStrokeIcon />;
	} else if (alertType === ALERT_TYPE.ERROR_ICON || alertType === ALERT_TYPE.WARNING) {
		icon = <WarningStrokeIcon />;
	} else if (alertType === ALERT_TYPE.ERROR) {
		icon = <WarningStrokeIcon />;
	}

	const ref = useRef();

	useEffect(() => {
		if (ref.current && scrollOnShow) {
			scrollToElement({ element: ref.current, offset: -20, disableSmoothScroll: false });
		}
	}, [ref.current, scrollOnShow]);

	return (
		<div
			ref={ref}
			role="alert"
			className={classNames("alert-message", className, {
				"alert-message--error": [ALERT_TYPE.ERROR, ALERT_TYPE.ERROR_ICON].includes(
					alertType
				),
				"alert-message--success": alertType === ALERT_TYPE.SUCCESS,
				"alert-message--warning": alertType === ALERT_TYPE.WARNING,
			})}
		>
			{message && (
				<div className="alert-message__message">
					{withIcon && icon}
					<Typography
						variant={TYPOGRAPHY_VARIANTS.REGULAR}
						className="alert-message__text"
						data-testid="alert-message"
					>
						{message}
					</Typography>
				</div>
			)}
			{children}
			{errors.length > 0 ? <List items={errors} /> : false}
		</div>
	);
};

AlertMessage.propTypes = {
	className: PropTypes.string,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
	alertType: alertTypeProptypes,
	scrollOnShow: PropTypes.bool,
	withIcon: PropTypes.bool,
};

export default AlertMessage;
